<template>
  <div class="block">
    <div v-if="this.$mq !== 'mobile'">
      <div class="figure">
        <div class="row">
          <div class="item">
            <div class="icon-stomach"></div>
            <h3>СПОСОБ ДЕЙСТВИЯ
            </h3>
            <p>Изжога возникает при забросе кислоты из желудка
              в пищевод. Гевискон<sup>®</sup> помогает уменьшать раздражение в пищеводе и создает защитный барьер на поверхности
              желудка, препятствующий появлению изжоги.*
            </p>
          </div>
          <div class="item">
            <div class="icon-clock"></div>
            <h3>ПРОДОЛЖИТЕЛЬНОСТЬ ДЕЙСТВИЯ
            </h3>
            <p>Гевискон начинает работать через 3 мин
              и действует до 4 часов.*
            </p>
          </div>
          <div class="item">
            <div class="icon-pocket"></div>
            <h3>Удобный формат</h3>
            <p>Удобный формат в виде индивидуального
              пакетика — удобно взять с собой!
            </p>
          </div>
        </div>
        <a  @click="sendGaLink('купить')"  href="https://www.eapteka.ru/goods/id309251/?utm_source=Afisha_SP&utm_medium=Buy_Button&utm_campaign=foodbol" target="_blank" class="button button-inverted">Купить</a>
        <div class="sub-text">*Инструкция по применению Гевискон<sup>®</sup> Двойное Действие в форме суспензии
        </div>
      </div>
    </div>
    <div v-if="this.$mq === 'mobile'">
      <div class="figure">
        <div  style="position: relative; width: 100%; margin: 0 auto; max-width: 500px">
        <swiper ref="mySwiper" :options="swiperOption">
          <swiper-slide>
            <div class="slide-item">
              <div class="icon-stomach"></div>
              <h3>СПОСОБ ДЕЙСТВИЯ
              </h3>
              <p>Изжога возникает при забросе кислоты из желудка
                в пищевод. Гевискон<sup>®</sup> помогает уменьшать раздражение в пищеводе и создает защитный
                барьер на поверхности желудка, препятствующий появлению изжоги.*

              </p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-item">
              <div class="icon-clock"></div>
              <h3>ПРОДОЛЖИТЕЛЬНОСТЬ ДЕЙСТВИЯ
              </h3>
              <p>Гевискон начинает работать через 3 мин
                и действует до 4 часов.*
              </p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-item">
              <div class="icon-pocket"></div>
              <h3>Удобный формат</h3>
              <p>Удобный формат в виде индивидуального
                пакетика — удобно взять с собой!
              </p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination  swiper-pagination-white" slot="pagination"></div>
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        </swiper>

        </div>
        <a @click="sendGaLink('купить')" href="https://www.eapteka.ru/goods/id309251/?utm_source=Afisha_SP&utm_medium=Buy_Button&utm_campaign=foodbol"  target="_blank" class="button button-inverted">Купить</a>
        <div class="sub-text">
          *Инструкция по применению Гевискон<sup>®</sup> Двойное Действие в форме суспензии
        </div>
      </div>
    </div>
    <div class="body"></div>
    <div class="pack"></div>
    <div class="b-top"></div>

  </div>
</template>

<script>
    import {swiper, swiperSlide} from 'vue-awesome-swiper'

    export default {
        name: "ProductSection",
        data() {
            return {
                swiperOption: {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination'
                    }
                },
            }
        },
        methods:{
            sendGaLink(title) {
                this.$ga.event('Ссылка', 'Переход по ссылке "' + title + '"', 1);
            }
        }
        ,
        components: {
            swiper,
            swiperSlide
        }
    }
</script>

<style scoped lang="scss">
  .b-top {
    background-image: url("../assets/images/product/bg-top.png");
    width: 200px;
    height: 166px;
    right: 0;
    top: 0;
    z-index: 1;
    position: absolute;
  }

  .body {
    background: url("../assets/images/product/person.png") no-repeat top center;
    width: 203px;
    height: 408px;
    position: absolute;
    left: calc(50% - 225px);
    bottom: calc(57vh - 186px);
  }

  .pack {
    background: url("../assets/images/product/pack.png") no-repeat top center;
    width: 387px;
    height: 165px;
    z-index: 10;
    position: absolute;
    left: calc(50% - 92px);
    bottom: calc(57vh - 47px);
  }

  .figure {
    width: 100%;
    height: 50vh;
    position: absolute;
    z-index: 5;
    bottom: 0;
    left: 0;
    background-image: url("../assets/images/product/bg.png");
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 7vh;
    h3 {
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      text-transform: uppercase;
    }
    p {
      font-size: 16px;
      font-weight: 300;
      line-height: 18px;
      text-align: center;
    }
    .sub-text {
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;
      text-align: center;
      margin-top: 10px;
    }
  }

  .block {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#128783+0,253d63+100 */
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#128783+0,253d63+100 */
    background: #128783; /* Old browsers */
    background: -moz-linear-gradient(top, #128783 0%, #253d63 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, #128783 0%, #253d63 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #128783 0%, #253d63 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#128783', endColorstr='#253d63', GradientType=0); /* IE6-9 */
  }

  .row {
    display: flex;
    width: 90%;
    margin: 7vh auto 0;
    justify-content: space-between;

    .item {
      flex-shrink: 1;
      flex-grow: 0;
      flex-basis: 33%;
      overflow: hidden;
    }
  }

  .icon-stomach {
    background-image: url("../assets/icons/ico__stomach.svg");
    background-repeat: no-repeat;
    background-size: cover;
    width: 51px;
    height: 49px;
    margin: 0 auto;
  }

  .icon-clock {
    background-image: url("../assets/icons/ico__clock.svg");
    background-repeat: no-repeat;
    background-size: cover;
    width: 51px;
    height: 49px;
    margin: 0 auto;

  }

  .icon-pocket {
    background-image: url("../assets/icons/ico__pocket.svg");
    background-repeat: no-repeat;
    background-size: cover;
    width: 51px;
    height: 49px;
    margin: 0 auto;

  }

  @media screen and (min-width: 768px) and (max-height: 680px) {
    .body {
      width: 150px;
      height: 371px;
      position: absolute;
      left: calc(50% - 128px);
      bottom: calc(67vh - 245px);
      background-size: contain;
    }
    .pack {
      width: 387px;
      height: 120px;
      z-index: 10;
      background-size: contain;
      position: absolute;
      left: calc(50% - 83px);
      bottom: calc(67vh - 71px);
    }
    .figure {
      height: 60vh;
      p {
        font-size: 14px;
        line-height: normal;
        margin: 2px;
      }
      h3 {
        margin: 0;
      }

    }
    .row {
      margin-top: 9vh;
    }

  }

  @media screen and (max-width: 768px) {
    .b-top {
      background-image: url("../assets/images/product/bg-top-mobile.png");
      width: 120px;
      height: 71px;
      background-size: contain;
      background-repeat: no-repeat;
      right: -2px;

    }
    .figure {
      background-image: url("../assets/images/product/bg-mobile.png");
      height: 57vh;
      padding-bottom: 80px;
      h3 {
        font-size: 13px;
        line-height: 12px;
        margin: 1vh;
      }
      p {
        font-size: 11px;
        line-height: normal;
        margin: 1vh;
      }
      .sub-text {
        font-size: 9px;
        line-height: 14px;
        margin-top: 10px;
      }
    }
    .body {
      background-image: url("../assets/images/product/person-mobile.png");
      width: 99px;
      height: 198px;
      background-size: cover;
      left: calc(50% - 111px);
      bottom: calc(57vh - 34px);
    }
    .pack {
      background-image: url("../assets/images/product/pack-mobile.png");
      width: 180px;
      height: 77px;
      background-size: cover;
      left: calc(50% - 46px);
      bottom: calc(57vh + 36px);
    }
    .slide-item {
     width: 80%;
      max-width: 500px;
      margin: 2vh auto;
      padding-bottom: 4vh;
    }


    .icon-stomach, .icon-pocket, .icon-clock{
      width: 12vmin;
      height: 12vmin;
      background-size: contain;

    }




  }
</style>